<template>
    <div id="background">
      <div id="gallery">
        <figure class="pic1">
          <img src="/images/gR8woaJ.jpg" alt="" />
        </figure>
        <figure class="pic2">
          <img src="/images/pdjkCeO.jpg" alt="" />
        </figure>
        <figure class="pic3">
          <img src="/images/CllDVVU.jpg" alt="" />
        </figure>
        <figure class="pic4">
          <img src="/images/CEdLLgE.jpg" alt="" />
        </figure>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AboutGallery'
  }
  </script>
  
  <style scoped>
 #background {
  height: 10vw;
  width: 100%;
  background-image: url(http://garchitecture.ca/php/images/headers/wood.jpg);
  padding-top: 20px;
}

@media (max-width: 992px) {
  #background {
    height: 30vh;
  }
}

@media (max-width: 768px) {
  #background {
    height: 20vh;
  }
}

@media (max-width: 480px) {
  #background {
    height: 50vh;
  }
}

#gallery {
  color: black;
  width: 800px;
  margin: auto;
}

@media (max-width: 992px) {
  #gallery {
    width: 100%;
    margin-left: 25vw;
  }
}

@media (max-width: 768px) {
  #gallery {
    margin-left: 5vw;
  }
}

#background img {
  height: 150px;
  margin: 0;
}

#background figure {
  float: left;
  position: relative;
  background-color: white;
  text-align: center;
  font-size: 15px;
  padding: 10px;
  margin: 10px;
  box-shadow: 1px 2px 3px black;
}

figure.pic1 {
  transform: rotate(-10deg);
  z-index: 1;
}

figure.pic2 {
  transform: rotate(15deg);
  z-index: 2;
}

figure.pic3 {
  transform: rotate(-25deg);
  z-index: 1;
}

figure.pic4 {
  transform: rotate(5deg);
  z-index: 1;
}

@media (max-width: 992px) {
  figure.pic4 {
    display: none;
  }
}

figure.pic5 {
  transform: rotate(5deg);
  z-index: 1;
}

figure.pic6 {
  transform: rotate(-8deg);
  z-index: 1;
}

figure.pic7 {
  transform: rotate(2deg);
  z-index: 1;
}

figure.pic8 {
  transform: rotate(-13deg);
  z-index: 1;
}

figure.pic9 {
  transform: rotate(-7deg);
  z-index: 1;
}

figure.pic10 {
  transform: rotate(2deg);
  z-index: 1;
}

figure.pic11 {
  transform: rotate(-3deg);
  z-index: 1;
}

figure.pic12 {
  transform: rotate(10deg);
  z-index: 1;
}

#background figure:hover {
  box-shadow: 5px 10px 100px black;
  transform: scale(1.1, 1.1);
  z-index: 20;
}
  </style>
  